import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { EventSystemDetailed } from '../../models/event-systems/event-system-detailed.model';
import { EventSystemComplete } from '../../models/event-systems/event-system-complete.model';

export const EventSystemActions = createActionGroup({
    source: 'Event Systems',
    events: {
        'Load event systems': emptyProps,
        'Get single event system': props<{ systemRef: string}>()
    }
})

export const EventSystemApiActions = createActionGroup({
    source: 'Event System API',
    events: {
        'Retrieve list of event systems': props<{eventSystems: EventSystemDetailed[]}>(),
        'Fetch single event system': props<{ eventSystem: EventSystemComplete}>()
    }
})